// extracted by mini-css-extract-plugin
export default {"DiningBooking_Stepper":"DiningBooking_DiningBooking_Stepper__rorY-"};